import React from "react"
import InputMask from "react-input-mask"
import axios from "axios"
import Text from "../Text"
import LoadingInput from "../LoadingInput"
import CityLocation from "./CityLocation"
import StateLocation from "./StateLocation"
import CheckBox from "../Checkbox"
import { stateLocationReq } from "../../api/branches"

export default function Address(props) {
  const [address, setAddress] = React.useState({})
  const [searchPostalCode, setSearchPostalCode] = React.useState(true)
  const [loading, setLoading] = React.useState(false)
  const [forceRender, setForceRender] = React.useState(false)
  const ref = React.useRef(null)

  // setForceRender(!forceRender)

  function onChange(e) {
    const newAddress = { ...address, [e.target.name]: e.target.value }
    setAddress(newAddress)
    props.onChange(newAddress)
  }

  function handleChangePostalCode(e) {
    const value = e.target.value.replace(/\D+/g, "")
    onChange({ target: { name: "postal_code", value } })

    if (searchPostalCode && value.length === 8) {
      setLoading(true)
      axios
        .get(`https://viacep.com.br/ws/${value}/json`)
        .then((cepResp) => {
          if (cepResp.data && !cepResp.data.erro) {
            const { cep, logradouro, bairro, localidade, uf, complemento } =
              cepResp.data

            return stateLocationReq({uf}).then((stateResp) => {
              const foundState = stateResp[0]
              console.log(foundState)
              return {
                ...address,
                state_id: foundState.id,
                state_location: foundState.id,
                state_uf: foundState.uf_code,
                state: foundState.state_name,
                postal_code: cep.replace(/\D+/g, "") || value,
                street: logradouro || "",
                district: bairro || "",
                complement: complemento || "",

              }
            })
          }
          throw new Error("CEP inválido ou não encontrado")
        })
        .then((newAddress) => {
          setAddress(newAddress)
          props.onChange(newAddress)
        })
        .catch((err) => console.error(err))
        .finally(() => {
          setLoading(false)
          setForceRender(!forceRender)
        })
    }
  }

  React.useEffect(() => {
    if (!props.data || !Object.keys(props.data).length) return
    setAddress({
      ...props.data,
      cityName: props.data.city || "",
    })
  }, [props.data])

  React.useEffect(() => {
    // setAddress(...address)
  }, [address])

  return (
    <div key={forceRender} className="row" ref={ref}>
      <div className="col-md-2 col-xs-12">
        <div className="form-group">
          <div className="form-label">
            <Text color="primary">CEP</Text>
            <InputMask
              className="form-control"
              mask="99999-999"
              maskChar=""
              value={address.postal_code || ""}
              onChange={handleChangePostalCode}
              // disabled={loading || props.loading || props.disabled}
            />
            <CheckBox
              disabled={loading || props.loading || props.disabled}
              onChange={() => setSearchPostalCode(!searchPostalCode)}
              checked={searchPostalCode}
              label="Pesquisa automática"
            />
          </div>
        </div>
      </div>

      <div className="col-md-3 col-xs-12">
        <StateLocation
          selected={address.state_id}
          // disabled={loading || props.loading || props.disabled}
          onChange={(stateId, ufCode) => {
            setLoading(true)
            stateLocationReq({ uf_code: ufCode })
              .then((resp) => {
                // console.log(resp)
                const foundState = resp[0]
                const newAddress = {
                  ...address,
                  state_id: foundState.id || "",
                  state_location: foundState.id || "",
                  state: foundState.state_name || "",
                }
                setAddress(newAddress)
                props.onChange(newAddress)
              })
              .catch((err) => console.log(err))
              .finally(() => setLoading(false))
          }}
        />
      </div> 

      <div className="col-md-3 col-xs-12">
        <CityLocation
          defaultInputValue={address.cityName}

          stateCode={address.state_uf}
          onChange={onChange}
        />
      </div>

      <div className="col-md-4 col-xs-12">
        <div className="form-group">
          <div className="form-label">
            <Text color="primary">Bairro</Text>
          </div>
          <LoadingInput
            name="district"
            value={address.district || ""}
            onChange={onChange}
            disabled={loading}
          />
        </div>
      </div>

      <div className="col-md-4 col-xs-12">
        <div className="form-group">
          <div className="form-label">
            <Text color="primary">Rua</Text>
          </div>
          <LoadingInput
            name="street"
            value={address.street || ""}
            onChange={onChange}
            disabled={loading}
          />
        </div>
      </div>

      <div className="col-md-4 col-xs-12">
        <div className="form-group">
          <div className="form-label">
            <Text color="primary">Número</Text>
          </div>
          <LoadingInput
            name="street_number"
            value={address.street_number || ""}
            onChange={onChange}
            disabled={loading}
          />
        </div>
      </div>

      <div className="col-md-4 col-xs-12">
        <div className="form-group">
          <div className="form-label">
            <Text color="primary">Complemento</Text>
          </div>
          <LoadingInput
            name="complement"
            value={address.complement || ""}
            onChange={onChange}
            disabled={loading}
          />
        </div>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/_components/Address/index.jsx